export default __webpack_public_path__ + "43f7adf100d9987f28696dc831f6e26b.png";